import type { Fetcher } from 'swr'
import useSWR from 'swr'

import { type PromotionsBarType } from '@/legacy-src/lib/strapi/types'

import { fetchPromotionsBar, getPromotionsBarCacheKey } from '../PromotionsBar.utils'

const promoBarFetcher: Fetcher<PromotionsBarType, [string, boolean]> = async (key) => {
  const [, isBusinessPage] = key

  const data = await fetchPromotionsBar({ isBusinessPage })

  return data
}

export const useGetPromotionsBar = ({ isBusinessPage = false }: { isBusinessPage?: boolean }) => {
  const { data } = useSWR(getPromotionsBarCacheKey(isBusinessPage), promoBarFetcher)

  const content = data?.content ?? ''
  const isVisible = data?.isVisible ?? false

  return {
    content,
    isVisible,
  }
}
